import actions from '@/store/call-actions'

export default {
    install: (Vue, { store }) => {
        Vue.prototype.$actions = actions(store);
    }
}
